import { render } from "./PrivacyPolicy.vue?vue&type=template&id=49617b14&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=49617b14&lang=css"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=49617b14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49617b14"]])

export default __exports__